import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import TextField from 'components/fields/TextField';
import FormError from 'components/common/FormError';
import AutosuggestField from 'components/fields/AutosuggestField';
import CheckboxField from 'components/fields/CheckboxField';

import {
  reassignNoteCategory,
  requestSearchNoteCategories,
} from 'redux/modules/noteCategories';

import { accountLoginFail } from 'redux/modules/account';

import * as validate from 'utils/validate';

import objectDiff from 'utils/objectDiff';

import NoteCategoryReassignOldNoteCategoryNameField from './NoteCategoryReassignOldNoteCategoryNameField';

const styles = () => ({
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
});

function onSubmit(values, dispatch, props) {
  const normalizeValues = (formValues) => {
    const normalizedValues = Object.assign({}, formValues);

    delete normalizedValues['Old Notes Category Name'];
    delete normalizedValues['New Notes Category Name'];
    delete normalizedValues['Selected New Notes Category Name'];

    return normalizedValues;
  };

  return new Promise((resolve, reject) => {
    dispatch(reassignNoteCategory({
      values: normalizeValues(values),
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      throw new SubmissionError({ _error: err.description });
    });
}

function onChange(values, dispatch, props) {
  if (values['New Notes Category ID']
    && values['Selected New Notes Category Name'] !== values['New Notes Category Name']) {
    dispatch(props.change('New Notes Category ID', null));
  }
}

const validateForm = (values) => {
  const errors = {};

  if (!values['New Notes Category ID']) {
    errors['New Notes Category Name'] = 'Please, select Note Category from list';
  }

  return errors;
};

const WorkflowStatusReassignDialogForm = ({
  handleSubmit,
  className,
  error,
  change,
  actions,
  classes,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
  >
    {error &&
      <Grid
        className={classes.grid}
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={6}
      >
        <Field
          id="Old Notes Category Name"
          name="Old Notes Category Name"
          label="Old Note Category"
          component={NoteCategoryReassignOldNoteCategoryNameField}
        />
      </Grid>
      <Grid
        item
        xs={6}
      >
        <Field
          id="New Notes Category Name"
          name="New Notes Category Name"
          label="New Note Category"
          component={AutosuggestField}
          errorPlacement="top"
          fullWidth
          renderSuggestionContent={suggestion => suggestion.Name}
          textFieldRef={(textFieldRef) => {
            if (textFieldRef) {
              textFieldRef.focus();
            }
          }}
          onSuggestionSelected={(suggestion) => {
            change('New Notes Category ID', suggestion.ID);
            change('Selected New Notes Category Name', suggestion.Name);
            return suggestion.Name;
          }}
          fetchSuggestions={({ value, limit, offset }) => (
            requestSearchNoteCategories({
                filters: [
                  ...value.length > 0
                    ? [{
                      name: 'Name',
                      operation: 'startswith',
                      val: value,
                      case_sensitivity: false,
                    }] : [],
                  {
                    name: 'Is Active',
                    operation: 'eq',
                    val: true,
                  },
                ],
                limit,
                offset,
              }).then(res => res.data,
                (err) => {
                  if (err.data.error === 'Need authorisation') {
                    actions.accountLoginFail();
                  }
                  return err;
                })
          )}
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Typography variant="caption">
          *All notes with old category will be changed to new category
        </Typography>
      </Grid>
    </Grid>
  </form>
);

WorkflowStatusReassignDialogForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
  }).isRequired,
};

WorkflowStatusReassignDialogForm.defaultProps = {
  className: '',
  error: null,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail }, dispatch),
});

export default connect(null, mapDispatchToProps)(reduxForm({
  form: 'reassignWorkflowStatus',
  onSubmit,
  onChange,
  validate: validateForm,
})(withStyles(styles)(WorkflowStatusReassignDialogForm)));



// WEBPACK FOOTER //
// ./src/components/settings/NoteCategoryReassignDialog/NoteCategoryReassignDialogForm.js